<script>
	export let value = {
    good: 0,
    suspect: 0,
    bad: 0,
    unknown: 0
  };

  export let labels = {
    good: "good",
    suspect: "suspect",
    bad: "bad",
    unknown: "unknown"
  }

  $: tooltip = getTooltip(value, labels);

  function getTooltip(value, labels) {
    if (value == undefined) return "";
    
    let chunks = [];
    chunks.push(value.good > 0 ? `${value.good} ${labels.good}` : "");
    chunks.push(value.suspect > 0 ? `${value.suspect} ${labels.suspect}` : "");
    chunks.push(value.bad > 0 ? `${value.bad} ${labels.bad}` : "");
    chunks.push(value.unknown > 0 ? `${value.unknown} ${labels.unknown}` : "");
    return chunks.filter(x => x).join(", ");
  }
</script>

<div title={tooltip}>
  {#if value == undefined}
    ?
  {:else}
    {#if value.good}<span style="color: green">{value.good}</span>{/if}
    {#if value.suspect}<span style="color: darkorange">{value.suspect}</span>{/if}
    {#if value.bad}<span style="color: red">{value.bad}</span>{/if}
    {#if value.unknown}<span style="color: gray">{`${value.unknown}?`}</span>{/if}
  {/if}
</div>

<style>
	div {
		display: flex;
		flex-direction: row;
		gap: 5px;
	}
  
  span {
    font-weight: bold;
  }
</style>